import { CheckCircle2, XCircle, CalendarCheck, MapPinCheck, Clock, DollarSign, Hourglass, Ban, Award, AlertCircle, Lock, WifiOff, Loader2, Inbox } from "lucide-react";

/**
 * Badge de status ACESSÍVEL (WCAG 2.2 AA): nunca depende só de cor —
 * combina sempre cor + texto + ícone. Fonte única de estados do design system.
 * Uso: <StatusBadge status="pago" />  ou  <StatusBadge status="pendente" label="Repasse pendente" />
 */
const STATES = {
  disponivel: { label: "Disponível", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30", Icon: CheckCircle2 },
  indisponivel: { label: "Indisponível", cls: "bg-zinc-800 text-zinc-400 border-zinc-700", Icon: XCircle },
  confirmado: { label: "Confirmado", cls: "bg-primary/20 text-primary border-primary/40 font-semibold", Icon: CalendarCheck },
  checkin_disponivel: { label: "Check-in disponível", cls: "bg-blue-500/20 text-blue-300 border-blue-500/40", Icon: MapPinCheck },
  aguardando: { label: "Aguardando confirmação", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30", Icon: Clock },
  pago: { label: "Pago", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40", Icon: DollarSign },
  pendente: { label: "Pendente", cls: "bg-amber-500/20 text-amber-300 border-amber-500/40", Icon: Hourglass },
  processando: { label: "Em processamento", cls: "bg-blue-500/15 text-blue-300 border-blue-500/30", Icon: Loader2 },
  cancelado: { label: "Cancelado", cls: "bg-rose-500/15 text-rose-400 border-rose-500/30", Icon: Ban },
  concluido: { label: "Concluído", cls: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30", Icon: Award },
  perfil_incompleto: { label: "Perfil incompleto", cls: "bg-purple-500/15 text-purple-300 border-purple-500/30", Icon: AlertCircle },
  bloqueado_plano: { label: "Bloqueado por plano", cls: "bg-orange-500/15 text-orange-400 border-orange-500/30", Icon: Lock },
  sem_conexao: { label: "Sem conexão", cls: "bg-zinc-800 text-rose-300 border-rose-500/40", Icon: WifiOff },
  vazio: { label: "Sem resultados", cls: "bg-zinc-800 text-zinc-400 border-zinc-700", Icon: Inbox },
};

export function StatusBadge({ status, label, size = "sm", pulse = false, className = "" }) {
  const s = STATES[status];
  if (!s) return null;
  const sizeCls = size === "lg" ? "text-sm px-3 py-1.5 gap-1.5" : "text-xs px-2.5 py-1 gap-1";
  const iconCls = size === "lg" ? "h-4 w-4" : "h-3.5 w-3.5";
  return (
    <span role="status" data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border font-medium leading-none ${s.cls} ${sizeCls} ${pulse ? "animate-pulse" : ""} ${className}`}>
      <s.Icon className={`${iconCls} shrink-0 ${status === "processando" ? "animate-spin" : ""}`} aria-hidden="true" />
      <span>{label || s.label}</span>
    </span>
  );
}

export const STATUS_STATES = STATES;
export default StatusBadge;
